<template>
  <div id="app">
    <router-view />
    <alert-message />
  </div>
</template>

<script>
/**
 * ==================================================================================
 * Main VUE component
 * ==================================================================================
 **/

import RouteGuard from '@/utils/mixins/routeGuard'
import CloudMessaging from '@/utils/mixins/cloudMessaging'
import ServiceWorkerUpdate from '@/utils/mixins/serviceWorkerUpdate'
import AlertMessage from '@/components/AlertMessage'

export default {
  metaInfo: function() {
    const title = 'Crown Hire'
    const description = 'A platform for tradies to hire and rent out equipment'
    return {
      titleTemplate: title => {
        return `${title ? title + ' | ' : ''}${this.$env.appName}`
      },
      meta: [
        {
          property: 'og:site_name',
          content: title
        },
        {
          property: 'og:title',
          content: title
        },
        {
          name: 'description',
          content: description
        },
        {
          property: 'og:description',
          content: description
        },
        {
          property: 'og:url',
          content: window.location.origin + this.$route.fullPath
        },
        {
          property: 'og:type',
          content: 'website'
        }
      ]
    }
  },
  components: {
    AlertMessage
  },
  mixins: [RouteGuard, CloudMessaging, ServiceWorkerUpdate]
}
</script>
